import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'IronScales/Deepfake/Meetings'

export const GET_DEEPFAKE_MEETINGS_ASYNC = createAsyncTypes('GET_DEEPFAKE_MEETINGS', typeKey)
export const GET_DEEPFAKE_ANALYTICS_ASYNC = createAsyncTypes('GET_DEEPFAKE_ANALYTICS', typeKey)
export const GET_DEEPFAKE_ANALYTICS_PREVIOUS_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_ANALYTICS_PREVIOUS',
  typeKey
)
export const GET_DEEPFAKE_CALL_DETAILS_ASYNC = createAsyncTypes(
  'GET_DEEPFAKE_CALL_DETAILS',
  typeKey
)

export const SET_DEEPFAKE_MEETINGS_FILTERS = 'SET_DEEPFAKE_MEETINGS_FILTERS'
export const SET_DEEPFAKE_MEETINGS_TIME_FILTER = 'SET_DEEPFAKE_MEETINGS_TIME_FILTER'
export const SET_DEEPFAKE_MEETINGS_ORDERING = 'SET_DEEPFAKE_MEETINGS_ORDERING'
export const SET_DEEPFAKE_MEETINGS_PAGE = 'SET_DEEPFAKE_MEETINGS_PAGE'
export const SET_DEEPFAKE_MEETINGS_PAGE_SIZE = 'SET_DEEPFAKE_MEETINGS_PAGE_SIZE'
export const CLEAR_DEEPFAKE_MEETINGS_FILTERS = 'CLEAR_DEEPFAKE_MEETINGS_FILTERS'
export const UPDATE_DEEPFAKE_MEETINGS_LAST_UPDATED = 'UPDATE_DEEPFAKE_MEETINGS_LAST_UPDATED'
export const SET_DEEPFAKE_MEETINGS_LIVE_ONLY = 'SET_DEEPFAKE_MEETINGS_LIVE_ONLY'

export const DEFAULT_MEETINGS_PAGE_SIZE = 50
export const DEFAULT_MEETINGS_ORDERING = '-start_time'
